import { userService } from "api/services/UserService";
import Button from "components/Button";
import { useAuth } from "contexts/AuthContext";
import { useState } from "react";
import { Link } from "react-router-dom";
import { UserProfile } from "types/userProfile";

export default function ProfileInformationForm() {

    const { user } = useAuth();
    const [profile, setProfile] = useState<UserProfile>({
        firstName: user?.firstName || '',
        lastName: user?.lastName || '',
        email: user?.email || '',
        phone: user?.phoneNumber || '',
        about: user?.description || ''
      });
      const [newEmail, setNewEmail] = useState<string>('');
      const [newPhone, setNewPhone] = useState<string>('');
      const [about, setAbout] = useState<string>(profile.about);
      const [password, setPassword] = useState<string>('');
    
    const handleProfileUpdate = (e: React.FormEvent) => {
        e.preventDefault();
        if (!user) return;
    
        userService.updateUser(user.id, profile)
        .then((result) => {
          if (result.isSuccess && result.data) {
            setProfile({
              firstName: result.data.firstName || '',
              lastName: result.data.lastName || '',
              email: result.data.email || '',
              phone: result.data.phoneNumber || '',
              about: result.data.description || ''
            });
          }
        })
        .then(() => alert('Profil bilgileri başarıyla güncellendi.'))
        .catch((error) => alert('Profil bilgileri güncellenemedi. Lütfen tekrar deneyin.'));
      };
    
    const handleSecurityUpdate = (e: React.FormEvent) => {
      e.preventDefault();
      if (!user) return;

      userService.updateUserSecurity(user.id, {
        password: password,
        email: newEmail || undefined,
        phoneNumber: newPhone || undefined
      })
      .then((result) => {
        if (result.isSuccess && result.data) {
          setProfile({
            firstName: result.data.firstName || '',
            lastName: result.data.lastName || '',
            email: result.data.email || '',
            phone: result.data.phoneNumber || '',
            about: result.data.description || ''
          });
          setNewEmail('');
          setNewPhone('');
          setPassword('');
          alert('Güvenlik bilgileri başarıyla güncellendi.');
        }
      })
      .catch((error) => alert('Güvenlik bilgileri güncellenemedi. Lütfen tekrar deneyin.'));
    }

    return (
        <>
        <form onSubmit={handleProfileUpdate}>
              <div className="card mb-4">
                <div className="card-body">
                  <h5 className="card-title mb-4">Profil Bilgileri</h5>
                  <div className="row">
                    <div className="col-md-6">
                      <label className="form-label">
                        Ad
                      </label>
                      <input 
                        className="form-control bg-light" 
                        readOnly 
                        type="text" 
                        value={profile.firstName}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">
                        Soyad
                      </label>
                      <input 
                        className="form-control bg-light" 
                        readOnly 
                        type="text" 
                        value={profile.lastName}
                      />
                    </div>
                  </div>
                  
                  <div className="mb-3 mt-3">
                    <label className="form-label">
                      Hakkımda
                    </label>
                    <textarea 
                      className="form-control" 
                      rows={3}
                      value={profile.about}
                      onChange={(e) => setProfile({...profile, about: e.target.value})}
                    ></textarea>
                  </div>
                  <Button className="btn btn-primary" type="submit">
                    Değişiklikleri Kaydet
                  </Button>
                </div>
              </div>
            </form>

            <div className="card mb-4">
              <div className="card-body">
                <h5 className="card-title mb-4">Güvenlik Ayarları</h5>
                <form onSubmit={handleSecurityUpdate}>
                  <div className="mb-3">
                    <label className="form-label">
                      Mevcut E-posta
                    </label>
                    <input 
                      className="form-control bg-light" 
                      disabled 
                      type="email" 
                      value={profile.email}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">
                      Yeni E-posta
                    </label>
                    <input 
                      className="form-control" 
                      required={false}
                      type="email"
                      value={newEmail}
                      onChange={(e) => setNewEmail(e.target.value)}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">
                      Mevcut Telefon Numarası
                    </label>
                    <input 
                      className="form-control bg-light" 
                      disabled 
                      type="tel" 
                      value={profile.phone || 'Henüz bir telefon numarası eklenmedi'}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">
                      Yeni Telefon Numarası
                    </label>
                    <input 
                      className="form-control" 
                      placeholder="05XX XXX XX XX" 
                      type="tel"
                      required={false}
                      value={newPhone}
                      onChange={(e) => setNewPhone(e.target.value)}
                    />
                    <div className="form-text">
                      Telefon numaranız iki faktörlü doğrulama ve güvenlik işlemleri için kullanılacaktır.
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">
                      Şifreniz
                    </label>
                    <input 
                      className="form-control" 
                      required 
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <div className="form-text">
                      Güvenliğiniz için mevcut şifrenizi girmeniz gerekmektedir.
                    </div>
                  </div>
                  <Link to="/sifre-degistir" className="btn btn-outline-primary me-2">
                    <i className="fas fa-key me-2"></i>Şifre Değiştir
                  </Link>
                  <Button className="btn btn-primary" type="submit">
                    Değişiklikleri Kaydet
                  </Button>
                </form>
              </div>
            </div>
        </>
    )
}